module.exports = __webpack_public_path__ + "img/thumb_2.216d069c.jpg";